import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import '../css/gapiLandingPage.css'
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const GapiLandingPage = () => {
    const navigate = useNavigate()
    const iosUrl = 'www.nacweb.ch'
    const androidUrl = 'www.google.com'


    const getMobileOS = () => {

        const ua = navigator.userAgent

        if (/android/i.test(ua)) {

            return 1

        }

        else if (/iPad|iPhone|iPod/.test(ua)) {

            return 2

        }

        return 0

    }
    const redirect = () => {
        const os = getMobileOS()
        if (os == 0) {
            navigate("/calendar")
        }
    }

    useEffect(() => {
        redirect()
    }, [])

    return (
        <div className='gland-container' >
            <p className='gland-title' >Accesso</p>
            <p className='gland-title' >Effettuato con successo</p>
            <IoMdCheckmarkCircleOutline size={'45pt'}/>
            <p className='gland-subtitle' >Ora è possbile tornare all'app per continuare l'utilizzo</p>
        </div>
    )
}

export default GapiLandingPage